import { componentQrl, inlinedQrl, useStore, useTaskQrl, useLexicalScope, _jsxC, _IMMUTABLE, _fnSignal } from "@builder.io/qwik";
import { Fragment } from "@builder.io/qwik/jsx-runtime";
import { Block } from "../../block.qwik.mjs";
import { InteractiveElement } from "../interactive-element.qwik.mjs";
import { getWrapperProps } from "./component-ref.helpers.qwik.mjs";
const ComponentRef = /* @__PURE__ */ componentQrl(/* @__PURE__ */ inlinedQrl((props) => {
  const state = useStore({
    Wrapper: props.isInteractive ? InteractiveElement : props.componentRef,
    shouldUpdate: false
  });
  useTaskQrl(/* @__PURE__ */ inlinedQrl(({ track }) => {
    const [props2] = useLexicalScope();
    track(() => props2.componentOptions);
    track(() => props2.blockChildren);
  }, "ComponentRef_component_useTask_IpU82pM3MjU", [
    props
  ]));
  return /* @__PURE__ */ _jsxC(Fragment, {
    children: props.componentRef ? /* @__PURE__ */ _jsxC(state.Wrapper, {
      ...getWrapperProps({
        componentOptions: props.componentOptions,
        builderBlock: props.builderBlock,
        context: props.context,
        componentRef: props.componentRef,
        linkComponent: props.linkComponent,
        includeBlockProps: props.includeBlockProps,
        isInteractive: props.isInteractive,
        contextValue: props.context
      }),
      children: (props.blockChildren || []).map((child) => {
        return /* @__PURE__ */ _jsxC(Block, {
          block: child,
          get context() {
            return props.context;
          },
          get registeredComponents() {
            return props.registeredComponents;
          },
          get linkComponent() {
            return props.linkComponent;
          },
          [_IMMUTABLE]: {
            context: _fnSignal((p0) => p0.context, [
              props
            ], "p0.context"),
            linkComponent: _fnSignal((p0) => p0.linkComponent, [
              props
            ], "p0.linkComponent"),
            registeredComponents: _fnSignal((p0) => p0.registeredComponents, [
              props
            ], "p0.registeredComponents")
          }
        }, 3, child.id);
      })
    }, 0, "z6_0") : null
  }, 1, "z6_1");
}, "ComponentRef_component_tFQoBV6UFdc"));
export {
  ComponentRef,
  ComponentRef as default
};
